import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StationRecentSearchesConfiguration {
  public maxOrigins = 3;
  public maxDestinations = 3;
  public deleteOptionEnabled = true;
}
